import { ErrorMessage, useField } from "formik";

import "./InputField.scss";
import { useState } from "react";

const InputField = ({ name, label, required, ...props }: any) => {
  const [field, meta] = useField(name);
  const [type, setType] = useState(props.type);
  const showPassword = () => {
    if (type == "password") {
      setType("text");
    } else {
      setType("password");
    }
  };
  return (
    <div className="Input-Field">
      <label className="Field-Label" htmlFor={field.name}>
        {label}
        {required === true ? (
          <label className="Field-Label-Red">&nbsp;*</label>
        ) : (
          ""
        )}
      </label>
      <input
        // TODO NE POSTOJI EFFECT
        maxLength={props.maxLength ? props.maxLength : 100}
        // className={`${
        //   meta.error && meta.touched ? "Input-Field-Box" : "Input-Field-Box"
        // }`}
        className="Input-Field-Box"
        autoComplete={name} //TODO CHECK
        {...field}
        {...props}
        type={type}
      />
      {props.type === "password" && (
        <div className="Input-Field-Checkbox">
          <input type="checkbox" onClick={showPassword} />
          <label>Prikaži lozinku</label>
        </div>
      )}

      <ErrorMessage
        name={field.name}
        component="label"
        className="Field-Error"
      />
    </div>
  );
};

export default InputField;
